import { Button } from 'src/components/atoms';
import { StyledIconInButton } from 'src/components/foundations/foundations.styles';
import { SelectAllButtonState } from '../LocalFilterSection';

interface SelectAllButtonProps {
  onSelectAll?: () => void;
  selectAllButtonCondition: SelectAllButtonState;
}

export const SelectAllButton = ({
  onSelectAll,
  selectAllButtonCondition,
}: SelectAllButtonProps) => {
  return (
    <>
      {onSelectAll && (
        <Button
          size="medium"
          variant="secondary"
          onClick={onSelectAll}
          data-testid={
            selectAllButtonCondition === SelectAllButtonState.CLEAR
              ? 'clear-all-button'
              : 'select-all-button'
          }
        >
          <StyledIconInButton
            size="small"
            position="left"
            className={
              selectAllButtonCondition === SelectAllButtonState.CLEAR
                ? 'uil uil-multiply'
                : 'uil uil-check'
            }
          />
          {selectAllButtonCondition}
        </Button>
      )}
    </>
  );
};
